import React from "react";

import "../styles/ConsultationPage.css";

function Consultation() {
  return (
    <main className="consultation-page">

      {/* ==========================================
          BACK TO SERVICES
      ========================================== */}

      <div className="consultation-back">
        <a
          href="/#services"
          className="consultation-back-link"
        >
          ← Back to All Services
        </a>
      </div>

      {/* ==========================================
          HERO
      ========================================== */}

      <section className="consultation-hero">
        <span className="consultation-eyebrow">
          Contents Documentation
        </span>

        <h1>
          Clear Documentation Through Every Stage of Recovery
        </h1>

        <p>
          When property damage disrupts your home or business, organized
          documentation can help make the recovery process easier to manage.
          The Right Pack Out provides detailed contents consultation,
          insurance reporting, and total loss inventory services designed
          to support homeowners, contractors, and insurance professionals.
        </p>
      </section>

      {/* ==========================================
          TRUST STRIP
      ========================================== */}

      <section className="consultation-trust-strip">

        <div className="consultation-trust-item">
          <strong>
            Detailed Records
          </strong>

          <span>
            Organized documentation helps keep affected contents accounted for
          </span>
        </div>

        <div className="consultation-trust-item">
          <strong>
            Clear Communication
          </strong>

          <span>
            Reports help support communication between everyone involved
          </span>
        </div>

        <div className="consultation-trust-item">
          <strong>
            Recovery Support
          </strong>

          <span>
            Documentation helps provide clarity throughout the claims process
          </span>
        </div>

      </section>

      {/* ==========================================
          DOCUMENTATION SERVICES
      ========================================== */}

      <section className="consultation-services">

        <div className="consultation-divider"></div>

        <div className="consultation-section-heading">
          <span>
            Documentation Services
          </span>

          <h2>
            Organized Information When Details Matter Most
          </h2>

          <p>
            From initial contents review to insurance documentation and
            total loss inventory, our goal is to provide clear, organized
            records throughout the recovery process.
          </p>
        </div>

        <div className="consultation-service-grid">

          <article className="consultation-service-card">
            <div className="consultation-service-icon">
              📋
            </div>

            <h3>
              Contents Consultation
            </h3>

            <p>
              Contents and project needs are reviewed to help identify
              documentation, handling, and recovery requirements.
            </p>
          </article>

          <article className="consultation-service-card">
            <div className="consultation-service-icon">
              📷
            </div>

            <h3>
              Photo Documentation
            </h3>

            <p>
              Affected contents can be photographed to help document
              condition and support organized project records.
            </p>
          </article>

          <article className="consultation-service-card">
            <div className="consultation-service-icon">
              📄
            </div>

            <h3>
              Insurance Reporting
            </h3>

            <p>
              Organized reports can help support communication with
              homeowners, contractors, adjusters, and insurance professionals.
            </p>
          </article>

          <article className="consultation-service-card">
            <div className="consultation-service-icon">
              🗂️
            </div>

            <h3>
              Total Loss Inventory
            </h3>

            <p>
              Items determined to be non-restorable can be documented
              and organized for loss records and claims support.
            </p>
          </article>

        </div>
      </section>

      {/* ==========================================
          FEATURE SECTION
      ========================================== */}

      <section className="consultation-feature">

        <div className="consultation-feature-copy">
          <span className="consultation-eyebrow">
            Organized From the Start
          </span>

          <h2>
            Documentation That Helps Keep the Process Moving
          </h2>

          <p>
            Restoration projects can involve homeowners, contractors,
            insurance professionals, contents specialists, and multiple
            stages of recovery. Clear documentation helps everyone understand
            what has been affected and what happens next.
          </p>

          <p>
            Our approach focuses on organized records, detailed observations,
            and clear reporting so important information remains easier to
            track throughout the project.
          </p>
        </div>

        <div className="consultation-feature-panel">
          <span className="consultation-feature-label">
            Clear Project Records
          </span>

          <h3>
            Documented. Organized. Accessible.
          </h3>

          <p>
            Thoughtful documentation helps create a clearer record of
            affected contents throughout the restoration and claims process.
          </p>
        </div>

      </section>

      {/* ==========================================
          SERVICE DETAILS
      ========================================== */}

      <section className="consultation-details">

        <div className="consultation-section-heading">
          <span>
            How We Can Help
          </span>

          <h2>
            Three Key Documentation Services
          </h2>
        </div>

        <div className="consultation-detail-grid">

          <article className="consultation-detail-card">

            <span className="consultation-detail-label">
              Contents Consultation
            </span>

            <h3>
              Understanding the Scope of the Project
            </h3>

            <p>
              Contents consultation helps identify affected belongings,
              project needs, documentation requirements, and possible next
              steps before restoration work moves forward.
            </p>

          </article>

          <article className="consultation-detail-card">

            <span className="consultation-detail-label">
              Insurance Reporting
            </span>

            <h3>
              Organized Information for Claims Communication
            </h3>

            <p>
              Detailed reports can include item information, photographs,
              condition notes, and other project documentation to help support
              communication during an insurance claim.
            </p>

          </article>

          <article className="consultation-detail-card">

            <span className="consultation-detail-label">
              Total Loss Inventory
            </span>

            <h3>
              Clear Records for Non-Restorable Contents
            </h3>

            <p>
              When belongings cannot be restored, organized inventory records
              can help document the loss and provide a clearer record for
              homeowners and insurance professionals.
            </p>

          </article>

        </div>
      </section>

      {/* ==========================================
          WHY CHOOSE US
      ========================================== */}

      <section className="consultation-benefits">

        <div className="consultation-section-heading">
          <span>
            Why Choose The Right Pack Out
          </span>

          <h2>
            Detailed Documentation With a Human Approach
          </h2>
        </div>

        <div className="consultation-benefit-grid">

          <div className="consultation-benefit-item">
            <strong>
              Organized Records
            </strong>

            <span>
              Documentation is structured to help keep project details
              easier to understand and track.
            </span>
          </div>

          <div className="consultation-benefit-item">
            <strong>
              Detailed Observations
            </strong>

            <span>
              Condition and project information can be recorded with
              attention to relevant details.
            </span>
          </div>

          <div className="consultation-benefit-item">
            <strong>
              Claims Support
            </strong>

            <span>
              Reports can support communication between property owners
              and insurance professionals.
            </span>
          </div>

          <div className="consultation-benefit-item">
            <strong>
              Professional Coordination
            </strong>

            <span>
              Documentation can help keep homeowners, contractors,
              and project partners informed.
            </span>
          </div>

        </div>
      </section>

      {/* ==========================================
          CLOSING SECTION
      ========================================== */}

      <section className="consultation-cta">

        <div className="consultation-cta-content">

          <div>
            <span>
              Clarity During Recovery
            </span>

            <h2>
              Organized Documentation When Every Detail Matters.
            </h2>

            <p className="consultation-cta-text">
              When you are ready to discuss contents consultation,
              insurance reporting, or total loss inventory, use the
              Request Assistance button in the header and our team can
              help determine the next steps.
            </p>
          </div>

        </div>

      </section>

    </main>
  );
}

export default Consultation;